import { Box } from '@mui/material';
import { Label } from '../Label';
import { Video, PreviewThumbnail } from './components';
import { Button } from '../Button';
import { useRef } from 'react';
import { useController } from 'react-hook-form';
import { HelperText } from '../HelperText';

export const SingleVideo = ({ name, label, control, defaultValue }) => {
  const inputRef = useRef(null);

  const { 
    field: { onChange, value },
    fieldState: { error }
  } = useController({ name, control, defaultValue });

  const handleClick = () => {
    inputRef?.current.click();
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      onChange(reader.result);
    };
  };

  const handleRemove = () => {
    onChange(undefined);
    inputRef.current.value = '';
  };

  return (
    <>
      <Label>{label}</Label>
      <Box sx={error
        ? { border: '#D82C0D 1px solid', borderRadius: '8px', bgcolor: '#FFF4F4', p: 2 }
        : {
            backgroundColor: '#ededed', p: 2, borderRadius: '8px' 
          }
        }
      >
        {value && (
          <Video src={value} alt='staged video' onRemove={handleRemove} />
        )}

        {!value && (
          <PreviewThumbnail />
        )}
      </Box>
      <input
        type='file'
        style={{ display: 'none' }}
        ref={inputRef}
        onChange={handleFileChange}
        accept='.mp4'
      />
      {error && (
        <HelperText message={error?.message} />
      )}
      <Button onClick={handleClick}>Choose file</Button>
    </>
  )
};